/**
 * Human names for system settings.
 *
 * A setting key is an address, not a label. Nobody at UNIFEMGA thinks of
 * "lending.arrears_default_threshold_days" — they think "how long overdue
 * before we call it a default". This lives in the shared package because both
 * the settings screen and the audit trail need the same words; two copies would
 * drift, and the audit trail is the one place where drift is unacceptable.
 */
export const SETTING_LABELS = {
    'org.name': 'Short name',
    'org.legal_name': 'Registered name',
    'org.email': 'Contact email address',
    'org.phone': 'Contact telephone number',
    'org.address': 'Postal address',
    'legal.terms_version': 'Terms and conditions version',
    'legal.privacy_version': 'Privacy policy version',
    'lending.financing_type': 'Financing type',
    'lending.charges_interest': 'Charges interest',
    'lending.charges_fees': 'Charges fees',
    'lending.charges_late_penalty': 'Charges late payment penalties',
    'lending.arrears_default_threshold_days': 'Days overdue before default',
    'lending.borrowing_suspension_months': 'Borrowing suspension after default',
    'lending.product_limits_approved': 'Loan product limits approved',
};
/** Unit shown beside a numeric setting, so "90" is never a bare number. */
export const SETTING_UNITS = {
    'lending.arrears_default_threshold_days': 'days',
    'lending.borrowing_suspension_months': 'months',
};
/**
 * The label for a key, falling back to a readable form of the last segment so a
 * setting added later is never rendered as a raw dotted path.
 */
export function settingLabel(key) {
    const known = SETTING_LABELS[key];
    if (known)
        return known;
    const tail = key.split('.').pop() ?? key;
    return tail.replace(/_/g, ' ').replace(/^./, (character) => character.toUpperCase());
}
//# sourceMappingURL=settings.js.map